export default "__VITE_ASSET__BYjIVNBb__"